import { getAcquisitionFormScriptUrl } from './loadConfig.js';

const FALLBACK_STYLESHEET_FILE = 'widget.css';

/**
 * URL of the acquisition form stylesheet, resolved from the running script so it
 * follows both whichever host serves the bundle (acquisition form host, Blazor
 * preview, dev) and which bundle is running — widget.js pairs with widget.css,
 * widget-projects.js with widget-projects.css.
 */
export function acquisitionFormStylesheetUrl() {
  const scriptUrl = getAcquisitionFormScriptUrl();

  if (!scriptUrl) return null;

  try {
    const scriptFile = new URL(scriptUrl).pathname.split('/').pop() || '';
    const stylesheetFile = scriptFile.endsWith('.js')
      ? scriptFile.replace(/\.js$/, '.css')
      : FALLBACK_STYLESHEET_FILE;

    const stylesheetUrl = new URL(stylesheetFile, scriptUrl);
    stylesheetUrl.searchParams.set('v', __WIDGET_BUILD_ID__);

    return stylesheetUrl.toString();
  } catch {
    return null;
  }
}

/**
 * Append the stylesheet to a shadow root as a <link> and resolve once it is
 * applied. An external sheet is allowed by listing our origin in the embedding
 * site's style-src; a <style> with text would require 'unsafe-inline'.
 */
export function linkStylesheet(shadowRoot, href) {
  return new Promise((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.addEventListener('load', resolve, { once: true });
    link.addEventListener('error', resolve, { once: true });
    shadowRoot.appendChild(link);
  });
}

const HEAD_MARKER = 'data-tm-acquisition-form-css';

let headStylesheet = null;

/**
 * Append the stylesheet to document.head as a <link>. intl-tel-input measures
 * the dropdown by moving it into document.body, so the rules have to exist in
 * the light DOM too or it comes out unstyled and far too tall.
 */
export function linkStylesheetToHead(href) {
  if (typeof document === 'undefined') return Promise.resolve();
  if (headStylesheet) return headStylesheet;
  if (document.head.querySelector(`link[${HEAD_MARKER}]`)) return Promise.resolve();

  headStylesheet = new Promise((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute(HEAD_MARKER, '');
    link.addEventListener('load', resolve, { once: true });
    link.addEventListener('error', resolve, { once: true });
    document.head.appendChild(link);
  });
  return headStylesheet;
}
